import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { Price } from '@/types';
import { useQuery } from '@tanstack/react-query';

type PriceListParams = {
  campaignCode?: string | null;
  isoCountryCode?: string;
};

export const getPriceList = ({
  campaignCode,
  isoCountryCode,
}: PriceListParams): Promise<Price[]> => {
  return axios.get('/api/v1/payments/price_lists', {
    params: {
      campaignCode: campaignCode ?? undefined,
      isoCountryCode,
    },
  });
};

type QueryFnType = typeof getPriceList;

type UsePriceListsOptions = PriceListParams & {
  config?: QueryConfig<QueryFnType>;
};

export const usePriceLists = ({
  campaignCode,
  isoCountryCode,
  config = {},
}: UsePriceListsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['payments/price_lists', { campaignCode, isoCountryCode }],
    queryFn: () => getPriceList({ campaignCode, isoCountryCode }),
  });
};
